import React from 'react';

const Modal = ({ children, onClose, modaltxt, closeButtonDisabled, btnnone }) => {
    return (
        <div className="modal d-block vr-modal" style={{ background: '#0000009e', }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content p-4 vr-modal-content" style={{ borderRadius: '12px' }}>
                    <div className="modal-header border-0 d-flex align-items-center justify-content-between" >
                        <div>
                            <h5 className="modal-title">{modaltxt}</h5>
                        </div>
                        <div>
                            <button type="button" className="close vr-modal-close" aria-label="Close"
                                disabled={closeButtonDisabled}
                                style={{
                                    width: "35px", borderRadius: "50%", height: "35px", background: "#F1F5F9",
                                    border: "none", color: "#94A3B8", display: "flex", alignItems: "center", justifyContent: 'center',
                                    background: closeButtonDisabled ? "#d1d5db" : "#F1F5F9",
                                    color: closeButtonDisabled ? "#9ca3af" : "#94A3B8",
                                    cursor: closeButtonDisabled ? "not-allowed" : "pointer",
                                    display:btnnone?"none":'',
                                }}
                                onClick={() => {
                                    if (!closeButtonDisabled) {
                                        onClose();
                                    }
                                }}
                                // onClick={onClose}
                                
                                >
                                <span aria-hidden="true" style={{
                                    fontSize: "26px", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%",
                                    paddingBottom: "2px"
                                }}>&times;</span>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Modal;
